module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8707/img/favicon.png"